module.exports = __webpack_public_path__ + "static/media/eye.d58934fe.png";